import script from "./SidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanel.vue?vue&type=script&setup=true&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=03e694b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e694b0"]])

export default __exports__